/* Susana Hogar theme script. No dependencies. */
(() => {
  const SH = window.SH || { routes: {}, strings: {} };
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const root = (SH.routes.root || '/').replace(/\/?$/, '/');

  /* ---------- Money ---------- */
  const money = (cents) => {
    const v = (cents / 100).toFixed(2).replace(/\.00$/, '');
    return '<span class="sh-price__cur">S/</span>' + v;
  };
  const priceHTML = (price, compare, extra = '') => {
    const sale = compare && compare > price;
    return '<div class="sh-price' + (sale ? ' sh-price--sale' : '') + ' ' + extra + '" data-price>' +
      '<span class="sh-price__now">' + money(price) + '</span>' +
      (sale ? '<span class="sh-price__compare">' + money(compare) + '</span>' : '') + '</div>';
  };

  /* ---------- Toast ---------- */
  let toastTimer;
  const toast = (msg, action) => {
    const t = $('[data-toast]');
    if (!t) return;
    t.textContent = '';
    const span = document.createElement('span');
    span.textContent = msg;
    t.appendChild(span);
    if (action) {
      const b = document.createElement('button');
      b.type = 'button';
      b.className = 'sh-toast__action';
      b.textContent = action.label;
      b.addEventListener('click', () => { t.classList.remove('is-visible'); action.run(); });
      t.appendChild(b);
    }
    t.classList.add('is-visible');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => t.classList.remove('is-visible'), action ? 4200 : 2600);
  };

  /* ---------- Header scroll state ---------- */
  const header = $('[data-header]');
  if (header) {
    const onScroll = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    const setH = () => document.documentElement.style.setProperty('--header-h', header.offsetHeight + 'px');
    setH();
    window.addEventListener('resize', setH);
  }

  /* ---------- Drawers ---------- */
  const overlay = $('[data-overlay]');
  let openDrawer = null;
  let lastFocus = null;
  const drawerOf = (name) => $('[data-drawer="' + name + '"]');
  const open = (name) => {
    const d = drawerOf(name);
    if (!d) return false;
    if (openDrawer && openDrawer !== d) close();
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    overlay && overlay.classList.add('is-open');
    document.body.classList.add('sh-lock');
    $$('[aria-controls="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'true'));
    openDrawer = d;
    setTimeout(() => (d.querySelector('[data-close]') || d).focus(), 60);
    return true;
  };
  const close = () => {
    if (!openDrawer) return;
    const d = openDrawer;
    d.classList.remove('is-open');
    overlay && overlay.classList.remove('is-open');
    document.body.classList.remove('sh-lock');
    $$('[aria-controls="' + d.id + '"]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    openDrawer = null;
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) {
      const name = opener.getAttribute('data-open');
      if (name === 'cart' && document.body.classList.contains('template-cart')) return;
      if (open(name)) e.preventDefault();
      return;
    }
    if (e.target.closest('[data-close]') || e.target === overlay) close();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') { close(); closePredict(); }
    if (e.key === 'Tab' && openDrawer) {
      const f = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])', openDrawer).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Mobile search ---------- */
  $$('[data-toggle-search]').forEach((btn) => {
    btn.addEventListener('click', () => {
      const box = document.getElementById(btn.getAttribute('aria-controls'));
      if (!box) return;
      const show = box.hidden;
      box.hidden = !show;
      btn.setAttribute('aria-expanded', String(show));
      if (show) { const i = $('input[type="search"]', box); i && i.focus(); }
    });
  });

  /* ---------- Cart ---------- */
  const updateCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; });
    $$('.sh-cartbtn').forEach((b) => { b.classList.remove('is-bump'); void b.offsetWidth; b.classList.add('is-bump'); });
  };
  const refreshCart = async (sectionsHTML) => {
    let html = sectionsHTML;
    if (!html) {
      const r = await fetch(root + '?sections=cart-drawer');
      html = await r.json();
    }
    if (html && html['cart-drawer']) {
      const doc = new DOMParser().parseFromString(html['cart-drawer'], 'text/html');
      const fresh = doc.querySelector('[data-cart-drawer-inner]');
      const cur = $('[data-cart-drawer-inner]');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    const page = $('[data-cart-page]');
    if (page) {
      const id = page.getAttribute('data-section-id');
      const r = await fetch(window.location.pathname + '?section_id=' + encodeURIComponent(id));
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.querySelector('[data-cart-page]');
      if (fresh) page.innerHTML = fresh.innerHTML;
    }
  };
  const addToCart = async (id, quantity = 1) => {
    const res = await fetch(SH.routes.cartAdd || '/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(id), quantity: Number(quantity) || 1 }], sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || SH.strings.error);
    await refreshCart(data.sections);
    const cart = await (await fetch(SH.routes.cart || '/cart.js')).json();
    updateCount(cart.item_count);
    return data;
  };
  const changeLine = async (line, quantity) => {
    const res = await fetch(SH.routes.cartChange || '/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Math.max(0, Number(quantity) || 0), sections: 'cart-drawer', sections_url: window.location.pathname })
    });
    const cart = await res.json();
    if (!res.ok) { toast(cart.description || SH.strings.error); return; }
    await refreshCart(cart.sections);
    updateCount(cart.item_count);
  };
  document.addEventListener('click', async (e) => {
    const quick = e.target.closest('[data-quick-add]');
    if (quick) {
      e.preventDefault();
      if (quick.getAttribute('aria-busy') === 'true') return;
      quick.setAttribute('aria-busy', 'true');
      try {
        await addToCart(quick.getAttribute('data-quick-add'), 1);
        quick.classList.add('is-added');
        const icon = quick.innerHTML;
        quick.innerHTML = '<svg class="sh-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
        setTimeout(() => { quick.classList.remove('is-added'); quick.innerHTML = icon; }, 1600);
        toast(SH.strings.added, { label: SH.strings.viewOrder, run: () => open('cart') });
      } catch (err) { toast(err.message || SH.strings.error); }
      quick.removeAttribute('aria-busy');
      return;
    }
    const change = e.target.closest('[data-line-change]');
    if (change) {
      e.preventDefault();
      change.disabled = true;
      await changeLine(change.getAttribute('data-line-change'), change.getAttribute('data-qty'));
    }
  });
  document.addEventListener('change', (e) => {
    const input = e.target.closest('[data-line-input]');
    if (input) changeLine(input.getAttribute('data-line-input'), input.value);
  });

  /* ---------- Quantity steppers (product page) ---------- */
  document.addEventListener('click', (e) => {
    const b = e.target.closest('[data-qty-step]');
    if (!b) return;
    const input = b.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    const next = Math.max(1, (parseInt(input.value, 10) || 1) + Number(b.getAttribute('data-qty-step')));
    input.value = next;
  });

  /* ---------- Product page ---------- */
  $$('[data-product-section]').forEach((section) => {
    const json = $('[data-product-json]', section);
    const form = $('[data-product-form]', section);
    if (!json || !form) return;
    const product = JSON.parse(json.textContent);
    const idInput = $('[data-variant-id]', form);
    const addBtn = $('[data-add-button]', form);
    const addLabel = $('[data-add-label]', form);
    const priceBox = $('[data-product-price]', section);
    const stock = $('[data-stock]', section);
    const stickyPrice = $('[data-sticky-price]', section);
    const stickyAdd = $('[data-sticky-add]', section);
    const main = $('[data-gallery-main]', section);

    const selected = () => $$('.sh-option', form).map((fs) => { const c = $('input:checked', fs); return c ? c.value : null; });
    const findVariant = (opts) => product.variants.find((v) => v.options.every((o, i) => o === opts[i]));

    const markAvailability = () => {
      const opts = selected();
      $$('.sh-option', form).forEach((fs, idx) => {
        $$('input', fs).forEach((input) => {
          const trial = opts.slice(); trial[idx] = input.value;
          const ok = product.variants.some((v) => v.available && v.options.every((o, i) => o === trial[i]));
          input.closest('.sh-pill').classList.toggle('sh-pill--unavailable', !ok);
        });
      });
    };

    const scrollToMedia = (mediaId) => {
      if (!main || !mediaId) return;
      const slide = main.querySelector('[data-media-id="' + mediaId + '"]');
      if (slide) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    };

    const applyVariant = (v) => {
      if (!v) {
        addBtn.disabled = true; addLabel.textContent = SH.strings.unavailable;
        if (stickyAdd) stickyAdd.disabled = true;
        return;
      }
      idInput.value = v.id;
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? SH.strings.addToOrder : SH.strings.soldOut;
      if (stickyAdd) stickyAdd.disabled = !v.available;
      if (priceBox) priceBox.innerHTML = priceHTML(v.price, v.compare_at_price, 'sh-price--lg');
      if (stickyPrice) stickyPrice.innerHTML = priceHTML(v.price);
      if (stock) {
        stock.classList.toggle('sh-stock--out', !v.available);
        stock.classList.remove('sh-stock--low');
        stock.textContent = v.available ? SH.strings.inStock : SH.strings.soldOut;
      }
      if (v.featured_media) scrollToMedia(v.featured_media.id);
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', url.toString());
    };

    form.addEventListener('change', (e) => {
      if (!e.target.matches('[data-option-index]')) return;
      markAvailability();
      applyVariant(findVariant(selected()));
    });
    if ($$('.sh-option', form).length) markAvailability();

    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      if (addBtn.disabled) return;
      addBtn.setAttribute('aria-busy', 'true');
      const qty = $('[data-qty-input]', form);
      try {
        await addToCart(idInput.value, qty ? qty.value : 1);
        toast(SH.strings.added);
        open('cart');
      } catch (err) { toast(err.message || SH.strings.error); }
      addBtn.removeAttribute('aria-busy');
    });

    if (stickyAdd) stickyAdd.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    const sticky = $('[data-sticky-buy]', section);
    if (sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(([entry]) => {
        const show = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        if (stickyAdd) stickyAdd.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
    }
  });

  /* ---------- Gallery ---------- */
  $$('[data-gallery]').forEach((g) => {
    const main = $('[data-gallery-main]', g);
    const thumbs = $$('[data-thumb]', g);
    const dots = $$('[data-gallery-dots] span', g);
    if (!main) return;
    thumbs.forEach((t) => t.addEventListener('click', () => {
      const i = Number(t.getAttribute('data-thumb'));
      const slide = main.children[i];
      if (slide) main.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }));
    let raf;
    main.addEventListener('scroll', () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const i = Math.round(main.scrollLeft / Math.max(1, main.clientWidth));
        thumbs.forEach((t, k) => t.setAttribute('aria-current', String(k === i)));
        dots.forEach((d, k) => d.classList.toggle('is-active', k === i));
      });
    }, { passive: true });
  });

  /* ---------- Tabs ---------- */
  $$('[data-tabs]').forEach((wrap) => {
    const tabs = $$('[role="tab"]', wrap);
    const select = (tab, focus) => {
      tabs.forEach((t) => {
        const on = t === tab;
        t.setAttribute('aria-selected', String(on));
        t.tabIndex = on ? 0 : -1;
        const panel = document.getElementById(t.getAttribute('aria-controls'));
        if (panel) panel.hidden = !on;
      });
      if (focus) tab.focus();
    };
    tabs.forEach((t, i) => {
      t.addEventListener('click', () => select(t));
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowRight') select(tabs[(i + 1) % tabs.length], true);
        if (e.key === 'ArrowLeft') select(tabs[(i - 1 + tabs.length) % tabs.length], true);
      });
    });
  });

  /* ---------- Predictive search ---------- */
  let predictTimer, predictCtrl;
  function closePredict() { $$('[data-predictive-results]').forEach((r) => { r.hidden = true; }); }
  $$('[data-predictive-form]').forEach((form) => {
    const input = $('[data-predictive-input]', form);
    const results = $('[data-predictive-results]', form);
    if (!input || !results || !SH.routes.predictive) return;
    input.setAttribute('role', 'combobox');
    input.setAttribute('aria-expanded', 'false');
    input.setAttribute('aria-autocomplete', 'list');
    const run = async () => {
      const q = input.value.trim();
      if (q.length < 2) { results.hidden = true; input.setAttribute('aria-expanded', 'false'); return; }
      if (predictCtrl) predictCtrl.abort();
      predictCtrl = new AbortController();
      try {
        const url = SH.routes.predictive + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last';
        const r = await fetch(url, { signal: predictCtrl.signal });
        const html = await r.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const body = doc.querySelector('.shopify-section') || doc.body;
        results.innerHTML = body.innerHTML;
        results.hidden = false;
        input.setAttribute('aria-expanded', 'true');
      } catch (err) { /* aborted */ }
    };
    input.addEventListener('input', () => { clearTimeout(predictTimer); predictTimer = setTimeout(run, 220); });
    input.addEventListener('focus', () => { if (results.innerHTML.trim() && input.value.trim().length > 1) results.hidden = false; });
    input.addEventListener('keydown', (e) => {
      const items = $$('.sh-predict__item', results);
      if (!items.length || results.hidden) return;
      const cur = items.findIndex((i) => i.getAttribute('aria-selected') === 'true');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        const next = e.key === 'ArrowDown' ? (cur + 1) % items.length : (cur - 1 + items.length) % items.length;
        items.forEach((i, k) => i.setAttribute('aria-selected', String(k === next)));
        input.setAttribute('aria-activedescendant', items[next].id);
      }
      if (e.key === 'Enter' && cur > -1) { e.preventDefault(); window.location.href = items[cur].href; }
    });
  });
  document.addEventListener('click', (e) => { if (!e.target.closest('[data-predictive-form]')) closePredict(); });

  /* ---------- Collection: sort, filters, load more ---------- */
  $$('[data-sort]').forEach((s) => s.addEventListener('change', () => s.form.submit()));
  /* Load more: append the next page in place. The pages loaded and the scroll position are
     kept in history.state, so the back button returns to the same spot with the same products. */
  const grid = $('[data-product-grid]');
  const pagEl = $('[data-pagination]');
  const readState = () => { try { return history.state || {}; } catch (err) { return {}; } };
  const writeState = (patch) => {
    try { history.replaceState(Object.assign({}, readState(), patch), ''); } catch (err) { /* rate limited, ignore */ }
  };
  const appendPage = async (url) => {
    const r = await fetch(url, { credentials: 'same-origin' });
    if (!r.ok) throw new Error('HTTP ' + r.status);
    const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
    const newGrid = doc.querySelector('[data-product-grid]');
    if (newGrid) Array.from(newGrid.children).forEach((c) => grid.appendChild(c));
    const newPag = doc.querySelector('[data-pagination]');
    if (newPag && pagEl) {
      ['.sh-pagination__info', '.sh-pagination__bar', '.sh-pages'].forEach((sel) => {
        const a = $(sel, pagEl), bEl = $(sel, newPag);
        if (a && bEl) a.innerHTML = bEl.innerHTML;
      });
      const btn = $('[data-load-more]', pagEl);
      const nextBtn = $('[data-load-more]', newPag);
      if (btn) { if (nextBtn) btn.href = nextBtn.href; else btn.remove(); }
    }
  };
  if (grid && pagEl) {
    pagEl.addEventListener('click', async (e) => {
      const btn = e.target.closest('[data-load-more]');
      if (!btn) return;
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      const url = btn.href;
      try {
        await appendPage(url);
        const loaded = (readState().shPages || []).concat([url]);
        writeState({ shPages: loaded });
      } catch (err) { window.location.href = url; return; }
      btn.removeAttribute('aria-busy');
    });

    // Remember where the shopper was before opening a product.
    const saveScroll = () => writeState({ shScroll: Math.round(window.scrollY) });
    grid.addEventListener('click', (e) => { if (e.target.closest('a[href]')) saveScroll(); }, true);
    window.addEventListener('pagehide', saveScroll);

    // Coming back: reload the extra pages that were open, then return to the same spot.
    const st = readState();
    const pages = Array.isArray(st.shPages) ? st.shPages : [];
    if (pages.length) {
      try { history.scrollRestoration = 'manual'; } catch (err) { /* ignore */ }
      grid.setAttribute('aria-busy', 'true');
      (async () => {
        for (const url of pages) {
          try { await appendPage(url); } catch (err) { break; }
        }
        grid.removeAttribute('aria-busy');
        if (typeof st.shScroll === 'number') window.scrollTo(0, st.shScroll);
      })();
    } else if (typeof st.shScroll === 'number' && st.shScroll > 0) {
      requestAnimationFrame(() => { if (window.scrollY === 0) window.scrollTo(0, st.shScroll); });
    }
  }

  /* ---------- Recommendations ---------- */
  $$('[data-recommendations]').forEach(async (el) => {
    const url = el.getAttribute('data-url');
    if (!url || el.children.length) return;
    try {
      const r = await fetch(url);
      const doc = new DOMParser().parseFromString(await r.text(), 'text/html');
      const fresh = doc.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    } catch (err) { /* ignore */ }
  });
})();
